<!--
  Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

<p-toolbar class="cpl-toolbar gm-application-toolbar">
  <gm-header id="gm-header" #header [useSidebar]="false"></gm-header>
  <div class="p-toolbar-group-end">
    <!-- User Menu -->
    <div class="mr-2 p-chip p-component p-chip-image user-chip" (click)="userMenu.toggle($event)">
      <p-avatar class="profile-avatar" [image]="userProfileUrl" size="normal" shape="circle" (onImageError)="onProfilePicError()" ariaLabel="User profile picture"></p-avatar>
      <div class="p-chip-text ng-star-inserted">{{userName}}</div>
    </div>
    <p-menu #userMenu [style]="{'minWidth':'300px'}"  [popup]="true" [model]="userMenuItems"></p-menu>
    <!-- Help Menu -->
<!--    <button pButton pRipple type="button" style="font-size:0.5rem;" id="helpMenuButton"><i class="pi pi-question" pButtonIcon></i>-->
<!--            class="p-button-rounded p-button-help p-button-outlined"-->
<!--            (click)="helpMenu.toggle($event)"></button>-->
<!--    <p-menu #helpMenu id="helpMenu" [popup]="true" [model]="helpMenuItems"></p-menu>-->
  </div>
</p-toolbar>
<div class="nav-toolbar">
    <!--    TODO Replace with megamenu vertical if possible -->
  <p-menubar id="navbar" [model]="navMenuItems | navToMenuItem" class="app-navbar"></p-menubar>
</div>
<!--<gm-breadcrumbs [isVisible]="false"></gm-breadcrumbs>-->
<p-confirmDialog header="Logout" icon="pi pi-exclamation-triangle" defaultFocus="reject"></p-confirmDialog>
<cpl-home class="home-component"></cpl-home>

<div>
<gm-footer id="cp-footer"></gm-footer>
</div>
